exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nSPAN[disabled] .vdpComponent.vdpWithInput[data-v-ee525e50] {\n}\n", ""]);

// exports
